export const AT_BLOCKER_SET =               'LIST_VIEW_BLOCKER_SET';
export const AT_COLLAPSED_GROUPS_SET =      'LIST_VIEW_COLLAPSED_GROUPS_SET';
export const AT_GROUP_BY_EPICS_TOGGLE =     'LIST_VIEW_GROUP_BY_EPICS_TOGGLE';
export const AT_ORDER_TYPE_SET =            'LIST_VIEW_ORDER_TYPE_SET';
export const AT_PRINT_MODE_SET =            'LIST_VIEW_PRINT_MODE_SET';
export const AT_SHOWN_FIELDS_SET =          'LIST_VIEW_SHOWN_FIELDS_SET';
export const AT_COLLAPSED_SET =         'LIST_VIEW_COLLAPSED_SET';
